import React from 'react';
import { Document, Page, View, Text } from '@react-pdf/renderer';
import { commonStyles, COLORS, formatExamDate, historyToString, calculateVolume, formatListItems, buildCombinedReason, getFacilityDisplayName } from '../utils/pdfHelpers';
import { PdfPageHeader, PdfPatientBox, PdfCallReport, PdfAccentSectionHeader, PdfSectionHeader, PdfLabelValue, PdfMeasurementBox, PdfCommentsBox, PdfFooter } from '../utils/PdfSharedComponents';

const NORMAL_CONUS = 'Normal (L1-L2)';
const NORMAL_HEMORRHAGE = 'None';

export function PediatricBrainSpinePDF({ data, facilityInfo }) {
  const reason = buildCombinedReason(data.reason, data.history);

  const brain = data.brain || {};
  const spine = data.spine || {};

  const findingsLines = [];
  if (brain.evaluated) {
    if (brain.parenchyma) findingsLines.push(`Brain parenchyma: ${brain.parenchyma}`);
    if (brain.hemorrhage) findingsLines.push(`Hemorrhage: ${brain.hemorrhage}`);
    if (brain.ventricles) findingsLines.push(`Ventricles: ${brain.ventricles}`);
  }
  if (spine.evaluated) {
    if (spine.conus) findingsLines.push(`Conus: ${spine.conus}`);
    if (spine.spinalCanal) findingsLines.push(`Spinal canal: ${spine.spinalCanal}`);
    if (spine.softTissues) findingsLines.push(`Soft tissues: ${spine.softTissues}`);
  }

  return (
    <Document>
      <Page size="LETTER" style={commonStyles.page}>
        <PdfPageHeader facilityInfo={facilityInfo} examTitle="PEDIATRIC BRAIN & SPINE ULTRASOUND WORKSHEET" />
        <PdfPatientBox
          firstName={data.firstName}
          lastName={data.lastName}
          mrn={data.mrn}
          examDate={data.examDate}
          technologist={data.technologist}
          studentWorksheet={data.studentWorksheet}
          supervisingSonographer={data.supervisingSonographer}
          reason={reason}
        />
        <PdfCallReport show={data.callReport} phoneNumber={data.phoneNumber} />

        <View style={commonStyles.twoCol}>
          <View style={commonStyles.colLeft}>
            <View style={commonStyles.measurementBox}>
              <Text style={[commonStyles.infoBoxText, { fontFamily: 'Helvetica-Bold', marginBottom: 4 }]}>FINDINGS SUMMARY</Text>
              <Text style={commonStyles.infoBoxText}>{findingsLines.join('\n') || 'No findings recorded'}</Text>
            </View>
            <PdfCommentsBox comments={data.comments} />
          </View>

          <View style={commonStyles.colRight}>
            {brain.evaluated && (
              <>
                <PdfAccentSectionHeader title="BRAIN" />
                <PdfLabelValue label="Parenchyma:" value={brain.parenchyma || ''} isAbnormal={brain.parenchyma && brain.parenchyma !== 'Normal'} />
                <PdfLabelValue label="Hemorrhage:" value={brain.hemorrhage || ''} isAbnormal={brain.hemorrhage && brain.hemorrhage !== NORMAL_HEMORRHAGE} />
                <PdfLabelValue label="Ventricles:" value={brain.ventricles || ''} isAbnormal={brain.ventricles && brain.ventricles !== 'Normal'} />
              </>
            )}

            {spine.evaluated && (
              <>
                <PdfAccentSectionHeader title="SPINE" />
                <PdfLabelValue label="Conus:" value={spine.conus || ''} isAbnormal={spine.conus && spine.conus !== NORMAL_CONUS} />
                <PdfLabelValue label="Spinal canal:" value={spine.spinalCanal || ''} isAbnormal={spine.spinalCanal && spine.spinalCanal !== 'Normal'} />
                <PdfLabelValue label="Soft tissues:" value={spine.softTissues || ''} isAbnormal={spine.softTissues && spine.softTissues !== 'Normal'} />
              </>
            )}
          </View>
        </View>

        <PdfFooter facilityInfo={facilityInfo} />
      </Page>
    </Document>
  );
}
